import { FC } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Headline, Layout, Sidebar, SideNav } from '@servicetitan/design-system';

import { ApiOperationGroupModel, ApiOperationModel } from '../models/api-operation-model';
import * as Styles from './docs.module.scss';

const ApiOperationTable: FC<{ apiEndpointsPath: string; apiOperations: ApiOperationModel[] }> = ({
    apiEndpointsPath,
    apiOperations,
}) => (
    <table className={Styles.simple}>
        <tbody>
            {apiOperations.map(operation => (
                <tr key={operation.operationId}>
                    <td className={Styles.operation}>
                        <Link
                            className={Styles.operationEndpoint}
                            to={`${apiEndpointsPath}/${operation.operationId}`}
                        >
                            <span className={Styles.operationMethod} data-method={operation.method}>
                                {operation.method}
                            </span>
                            <span className={Styles.operationPath}>{operation.shortPath}</span>
                        </Link>
                    </td>
                    <td>{operation.summary}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export const ApiOperationList: FC<{
    apiEndpointsPath: string;
    apiOperationGroups: ApiOperationGroupModel[];
}> = ({ apiEndpointsPath, apiOperationGroups }) => (
    <Layout>
        {apiOperationGroups.map(apiOperationGroup => (
            <Layout.Section key={apiOperationGroup.tag}>
                <Headline>{apiOperationGroup.tag}</Headline>
                <ApiOperationTable
                    apiEndpointsPath={apiEndpointsPath}
                    apiOperations={apiOperationGroup.operations}
                />
            </Layout.Section>
        ))}
    </Layout>
);
ApiOperationList.displayName = 'ApiOperationList';

export const ApiOperationListSidebar: FC<{
    apiEndpointsPath: string;
    apiOperationGroups: ApiOperationGroupModel[];
    activeOperationId: string;
}> = ({ apiEndpointsPath, apiOperationGroups, activeOperationId }) => {
    const history = useHistory();
    const optionalBreak = '\u200B';

    return (
        <Sidebar localStorageKey="sidebar:docs">
            <SideNav title={<Link to={apiEndpointsPath}>API Endpoints</Link>}>
                {apiOperationGroups.map(apiOperationGroup => (
                    <SideNav.Group key={apiOperationGroup.tag} title={apiOperationGroup.tag}>
                        {apiOperationGroup.operations.map(apiOperation => (
                            <SideNav.Item
                                key={apiOperation.operationId}
                                active={apiOperation.operationId === activeOperationId}
                                onClick={() => {
                                    history.push(`${apiEndpointsPath}/${apiOperation.operationId}`);
                                }}
                            >
                                <div className={Styles.operationEndpoint}>
                                    <span
                                        className={Styles.operationMethod}
                                        data-method={apiOperation.method}
                                    >
                                        {apiOperation.method}
                                    </span>{' '}
                                    <span className={Styles.operationPath}>
                                        {apiOperation.shortPath.replaceAll(
                                            '/',
                                            '/' + optionalBreak,
                                        )}
                                    </span>
                                </div>
                            </SideNav.Item>
                        ))}
                    </SideNav.Group>
                ))}
            </SideNav>
        </Sidebar>
    );
};
ApiOperationListSidebar.displayName = 'ApiOperationListSidebar';
